import extractErrorMessage from '../../../shared/utils/extractErrorMessage';
import { publicClient } from '../../../shared/api/client';

export const AuthAPI = {
  // Dashboard prijava: korisnicko ime (ime.prezime, moze i sa @ ispred) + PIN
  // od 5 cifara. PIN ide kao `password`.
  login: async ({ username, pin }) => {
    try {
      const response = await publicClient.post('auth/login', {
        username: username.trim(),
        password: pin,
        userType: 'dashboard',
      });
      const { user, accessToken } = response.data || {};
      return {
        data: user ? { ...user, token: accessToken } : null,
        success: Boolean(user && accessToken),
      };
    } catch (error) {
      const message = extractErrorMessage(
        error,
        'Doslo je do greske pri prijavi.'
      );
      return {
        data: null,
        success: false,
        message: message,
        code: error?.response?.data?.code || null,
      };
    }
  },

  // Zaboravljen PIN: `identifier` je korisnicko ime ili email. Bek uvek vraca
  // istu genericku poruku (mejl dobija samo super admin), pa se ovde nista ne
  // grana osim na mreznu gresku.
  forgotPin: async ({ identifier }) => {
    try {
      const response = await publicClient.post('auth/forgot-pin', {
        identifier: identifier.trim(),
      });
      return {
        data: response.data,
        status: response.status,
        ok: response.status >= 200 && response.status < 300,
        message: response.data?.message || null,
      };
    } catch (error) {
      return {
        data: null,
        status: error?.response?.status || null,
        ok: false,
        message: extractErrorMessage(
          error,
          'Došlo je do greške pri slanju zahteva za reset PIN-a.'
        ),
      };
    }
  },

  resetPin: async ({ token, pin }) => {
    try {
      const response = await publicClient.post('auth/reset-pin', {
        token,
        pin,
      });
      return {
        data: response.data,
        status: response.status,
        ok: response.status >= 200 && response.status < 300,
        message: response.data?.message || 'PIN je promenjen.',
      };
    } catch (error) {
      return {
        data: null,
        status: error?.response?.status || null,
        ok: false,
        message: extractErrorMessage(
          error,
          'Došlo je do greške pri promeni PIN-a.'
        ),
        code: error?.response?.data?.code || null,
      };
    }
  },

  resetPassword: async ({ password, passwordToken }) => {
    try {
      const response = await publicClient.put(
        `auth/reset-password/${passwordToken}`,
        { password }
      );
      return response.data;
    } catch (error) {
      const message = extractErrorMessage(
        error,
        'Doslo je do greske pri promeni lozinke.'
      );
      return { data: null, success: false, message: message };
    }
  },

  forgotPassword: async ({ email }) => {
    try {
      const response = await publicClient.post('auth/forgot-password', {
        email,
      });
      return response.data;
    } catch (error) {
      const message = extractErrorMessage(
        error,
        'Doslo je do greske pri slanju email-a za restartovanje lozinke.'
      );
      return { data: null, success: false, message: message };
    }
  },
};
